/**
 * This service manages the volatile (in-memory) authentication state.
 * Because these variables are not stored in localStorage or sessionStorage,
 * they are completely wiped whenever the page is Reloaded (F5) or Closed.
 */

let volatileAuthState = false;
let volatileAuthToken: string | null = null;

export const authSession = {
  login: (token: string) => {
    volatileAuthState = true;
    volatileAuthToken = token;
    // We still store a shadowed copy in session for API calls, 
    // but the Guard will ignore it if volatileAuthState is false.
    sessionStorage.setItem('ast_token_shadow', token);
  },
  logout: () => {
    volatileAuthState = false;
    volatileAuthToken = null;
    sessionStorage.removeItem('ast_token_shadow');
  },
  isAuthenticated: () => {
    return volatileAuthState;
  },
  getToken: () => {
    return volatileAuthToken || sessionStorage.getItem('ast_token_shadow');
  }
};
